import httpClient, { paramsToString } from '@/services/http/httpClient'

export const apiGetReport = sinisterId => {
  const params = new URLSearchParams()
  params.append('sinister_id', sinisterId)
  return httpClient.get(`claimData${paramsToString(params)}`)
}
